import { type ThemeParser } from '../../../core/theme';
import { util } from 'echarts/core';

const sankeySeriesOption = {
  type: 'sankey',
  nodeWidth: 12,
  nodeGap: 0,
  left: 0,
  top: 70,
  right: 0,
  bottom: 70,
  animation: true,
  draggable: false,
  dvEdgeSilent: true,
  universalTransition: false,
  dvNodeLengthPercent: 0.5,
  label: {
    valueAnimation: true
  },
  orient: 'vertical',
  dvRootHeight: 58,
  itemStyle: {
    borderColor: 'rgba(255,255,255,0)',
    borderWidth: 4
  },
  lineStyle: {
    color: 'target',
    opacity: 0.2
  },
  emphasis: {
    focus: 'adjacency'
  },
  labelLayout: {
    hideOverlap: true
  },
  tooltip: {
    backgroundColor: '#3B3B3B',
    borderWidth: 0,
    padding: 8
  },
  data: []
};

function parseSankeySeries(option: Parameters<ThemeParser>[0]) {
  sankeySeriesOption.data = [];
  let rootDepth: number;
  option.series = option.series.map(item => {
    if (item.type !== 'sankey' || (item.type === 'sankey' && item.dvLayout !== 'tree')) {
      return item;
    }
    /** links负值时
     *  处理成正值用以绘图
     *  处理target节点的样式
     *  */
    item.links.map(ele => {
      // 当前连线的两个节点的层级
      let sourceDepth, targetDepth;
      item.data.forEach(seq => {
        if (seq.name == ele.target) {
          sourceDepth = seq.depth;
        }
        if (seq.name == ele.source) {
          targetDepth = seq.depth;
        }
      });

      // 同层节点默认连接线为bottom（后续线的位置计算判断条件会用到）
      if (sourceDepth === targetDepth && !ele.dvDirection) {
        ele.dvDirection = 'bottom';
      }

      // 负值处理
      if (ele.value < 0) {
        ele.values = true;
        ele.value = Math.abs(ele.value);
      }
    });
    /**
     * 为sankeySeriesOption配置项中的data添加配置
     * 查找tree root节点
     */
    item.data.map((ele, i) => {
      // 配置label（formatter&rich）
      sankeySeriesOption.data.push({
        label: {
          distance: 2
        }
      });
      if (ele.root === true) {
        rootDepth = ele.depth;
        sankeySeriesOption.data[i].label.position =
          (item.orient || sankeySeriesOption.orient) === 'vertical' ? 'inside' : 'top';
        (item.orient || sankeySeriesOption.orient) === 'horizontal' &&
          (sankeySeriesOption.data[i].label.distance = 8);
      } else {
        sankeySeriesOption.data[i].label.position =
          (item.orient || sankeySeriesOption.orient) === 'vertical' ? 'top' : 'left';
      }
    });
    /**
     * 根据root节点处理label
     */
    item.data.map((ele, i) => {
      // 处理位置
      if (ele.depth > rootDepth) {
        sankeySeriesOption.data[i].label.position =
          (item.orient || sankeySeriesOption.orient) === 'vertical' ? 'bottom' : 'right';
      }
    });
    // 属性值为数组，merge方法默认是覆盖
    const defaultOptionData = util.merge(sankeySeriesOption.data, {}, true);
    const mergeOption = util.merge(sankeySeriesOption, item, true);
    mergeOption.data = util.merge(defaultOptionData, mergeOption.data, true);
    return mergeOption;
  });
}

/**
 * 桑基图解析器
 */
export function sankeyThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const option = args[0];
  parseSankeySeries(option);
}
